/**
 * Pick the SVG `d` a Discover row hoodmark should draw (WEB-787).
 *
 * Prefer the local seed projection (unique per neighborhood, available on
 * both hosts without API-1657). Use a fetched boundary only when it carries
 * more vertices than the seed quad — the honest upgrade path once denser
 * rings land. Never return a shared hexagon: the last-resort glyph is the
 * documented rectangle in `static-fallback.ts`.
 */
import { getCltSeedFootprintPath } from '@/lib/neighborhoods/clt-seed-footprints';
import { STATIC_FOOTPRINT_FALLBACK_PATH } from '@/lib/neighborhoods/static-fallback';

export interface HoodmarkPathInput {
  readonly slug: string | null;
  /** API-1657 path when `useNeighborhoodFootprints` status is `loaded`. */
  readonly apiPath: string | null;
}

function pathVertexCount(d: string): number {
  return (d.match(/[ML]/gi) ?? []).length;
}

export function resolveHoodmarkPath({ slug, apiPath }: HoodmarkPathInput): string {
  const seed = slug ? getCltSeedFootprintPath(slug) : null;
  if (apiPath && seed && pathVertexCount(apiPath) > pathVertexCount(seed)) {
    return apiPath;
  }
  return seed ?? apiPath ?? STATIC_FOOTPRINT_FALLBACK_PATH;
}
